export const prettyJSON = (json: string) => JSON.stringify(JSON.parse(json || ''), undefined, 2);

export const formatJsonValue = (value: unknown) => {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'string') {
        try {
            return prettyJSON(value);
        } catch {
            return value;
        }
    }
    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return String(value);
    }
};
